import React from 'react'
import CruiseSearchCruiseLineSelect from './CruiseLineInputFilter'
import CruiseWhenFilter from './CruiseWhenInputFilter'
import CruiseDepartureFilter from './CruiseDepartureFilter'
import CruiseDestinationFilter from './CruiseDestinationFilter'
import noop from 'lib/noop'

interface Props {
  onChange?: (values: App.CruiseGlobalFilters) => void;
  dropdownAnchorRef?: React.RefObject<HTMLElement>;
}

function CruiseSearchFormInputs({ onChange = noop, dropdownAnchorRef }: Props) {
  return <>
    <CruiseDestinationFilter onChange={onChange} />
    <CruiseDepartureFilter onChange={onChange} />
    <CruiseSearchCruiseLineSelect onChange={onChange} dropdownAnchorRef={dropdownAnchorRef} />
    <CruiseWhenFilter onChange={onChange} dropdownAnchorRef={dropdownAnchorRef} />
  </>
}

export default CruiseSearchFormInputs
